export class AsyncGroup {
  #locked = false;
  #queue: (() => void)[] = [];

  async enter(): Promise<void> {
    if (this.#locked) {
      await new Promise<void>(resolve => this.#queue.push(resolve));
    }
    this.#locked = true;
  }

  exit() {
    if (this.#queue.length > 0) {
      const resolve = this.#queue.shift();
      if (resolve) {
        resolve();
      }
    } else {
      this.#locked = false;
    }
  }

  async with<T>(callback: () => Promise<T>): Promise<T> {
    await this.enter();
    try {
      return await callback();
    } finally {
      this.exit();
    }
  }
}
